// extracted by mini-css-extract-plugin
export var box = "_4u-0";
export var check = "_4u-1";
export var checkboxButton = "_4u-6";
export var checkboxGroup = "_4u-5";
export var disabled = "_4u-7";
export var ghost = "_4u-9";
export var input = "_4u-2";
export var label = "_4u-4";
export var normal = "_4u-8";
export var uncheck = "_4u-3";